import { useState } from 'react';

export default function SearchBar({
  value = '',
  onChange,
  placeholder = 'Search...',
}) {
  const [isFocused, setIsFocused] = useState(false);

  const inputStyle = {
    width: '100%',
    padding: '13px 16px',
    borderRadius: 14,
    border: isFocused ? '1px solid #94a3b8' : '1px solid #dbe3ee',
    outline: 'none',
    fontSize: 14,
    boxSizing: 'border-box',
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
    boxShadow: isFocused
      ? '0 0 0 4px rgba(148, 163, 184, 0.15)'
      : '0 6px 16px rgba(15, 23, 42, 0.04)',
    backgroundColor: '#ffffff',
    color: '#111827',
  };

  return (
    <input
      type="text"
      value={value}
      placeholder={placeholder}
      onChange={onChange}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      style={inputStyle}
    />
  );
}
